<template>
    <div class="col-span-2 md:col-span-4 flex gap-4 md:gap-4 lg:gap-9 barbuttons items-end">
        <button v-if="mainMenu" v-for="(item, index) in mainMenu.items" :key="index" @click="$emit('toggleDropdown', item.title)"
            :class="{ 'underline underline-offset-4 decoration-2': currentMenu === item.title }"
            class="large hover:underline underline-offset-4 decoration-2 hidden md:block whitespace-nowrap"
            :style="'color:' + iconColor">
            {{ item.title }}
        </button>
        <a href="https://gravaa.myshopify.com/account" class="inline md:hidden self-end" aria-label="Login">
            <IconUser class="w-5" :color="iconColor" />
        </a>
        <NuxtLink to="#" class=" block md:hidden" aria-label="Search">
            <IconSearch @click="$emit('toggleSearch')" class="w-8" :color="iconColor" />
        </NuxtLink>
    </div>

</template>
<script setup>

defineProps({
    mainMenu: {
        type: Object,
        required: true
    },
    iconColor: {
        type: String,
        required: true
    },
    currentMenu: {
        type: String,
        required: true
    }
});

</script>

<style scoped>

header .barbuttons button{
  transition: color 0.5s ease;
  transition-delay: 0s;
  font-variation-settings: 'wght' 600, 'wdth' 100, 'slnt' 0;
  
}

header.transparentbg .barbuttons button {
  color: white;
  transition-delay: .3s;
}

</style>